import { createAsyncThunk } from '@reduxjs/toolkit';

import { removeUndefined } from 'commonUtils/removeUndefined';

import { sendSentryClientErrorOnce } from 'shared/lib';
import type { TPreApprovalsSearchApplicationRequest } from 'shared/types/TCreditselectionService';
import type { TLoansContactData } from 'shared/types/TLoansService';

import { areSelectedStepsFullFilled, checkIsFormFullFilledSelector } from 'entities/creditForm';
import { selectIsAnketaPage, selectIsOffersPage } from 'entities/siteSettings';
import { isLoggedSelector } from 'entities/user';
import { collectWLOtherDataSelector } from 'entities/whiteLabels';

import { STEPS_TO_CHECK } from 'features/SendPreApprovalsSearchApplication/constants';

import { sendPreApprovalsSearchApplicationApi } from '../model/sendPreApprovalsSearchApplication.query';

type TPayload = {
  sourceUrl: string;
  deviceType: TLoansContactData['client']['deviceType'];
};

export const sendPreApprovalsSearchApplicationThunk = createAsyncThunk<
  boolean,
  TPayload,
  { state: Pick<Store, 'creditForm' | 'whiteLabel' | 'user' | 'siteSettings'> }
>('sendPreApprovalsApplication/sendPreApprovalsSearchApplicationThunk', async (payload, { dispatch, getState }) => {
  const { sourceUrl, deviceType } = payload;

  const otherWlData = collectWLOtherDataSelector(getState());
  const isLoggedIn = isLoggedSelector(getState());
  const isFullFilledForm = checkIsFormFullFilledSelector(getState());
  const isAvailableToSendApplication = areSelectedStepsFullFilled(STEPS_TO_CHECK)(getState());
  const isAnketaPage = selectIsAnketaPage(getState());
  const isOffersPage = selectIsOffersPage(getState());

  if (!isAnketaPage && !isOffersPage) {
    return false;
  }

  if (!isLoggedIn) {
    return false;
  }

  if (!isAvailableToSendApplication) {
    return false;
  }

  const data: TPreApprovalsSearchApplicationRequest = {
    client: {
      sourceUrl,
      deviceType,
    },
    other: {
      ...otherWlData,
    },
    isFullProfile: isFullFilledForm,
  };

  try {
    await dispatch(
      sendPreApprovalsSearchApplicationApi.endpoints.sendPreApprovalsSearchApplication.initiate(removeUndefined(data)),
    ).unwrap();
    return true;
  } catch (error) {
    sendSentryClientErrorOnce('sendPreApprovalsSearchApplicationThunk', error);
    return false;
  }
});
